var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0.722656C25.3366 0.722656 32.5 7.8861 32.5 16.7227C32.5 25.5592 25.3366 32.7227 16.5 32.7227C7.66344 32.7227 0.5 25.5592 0.5 16.7227C0.5 7.8861 7.66344 0.722656 16.5 0.722656ZM25.6816 10.6279C25.1325 10.0788 24.263 10.0449 23.6738 10.5254L23.5596 10.6279L13.9854 20.2021L10.5205 16.7373C9.93472 16.1515 8.98519 16.1515 8.39941 16.7373C7.81367 17.3231 7.81367 18.2726 8.39941 18.8584L12.9248 23.3838C13.5106 23.9693 14.4612 23.9695 15.0469 23.3838L25.6816 12.749L25.7842 12.6357C26.2646 12.0467 26.2305 11.1771 25.6816 10.6279Z",
    fill: "#2D38AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.3460834c8731c58ad5f6691af2034435.svg";
export { ForwardRef as ReactComponent };